import { useContext } from "react";

import { OneDriveSyncContext } from "./OneDriveSyncContext";

export function useOneDriveSync() {
  const context = useContext(OneDriveSyncContext);
  if (!context) {
    throw new Error("useOneDriveSync must be used within a OneDriveSyncProvider");
  }
  return context;
}
